<template>
  <footer v-show="!hideFooter" class="footer">
    <div class="footer_inner">
      <p class="footer_logo">멀티캠퍼스</p>
      <ul class="footer_menu">
        <li><a href="https://www.multicampus.com/publish/popup/multicampus_map.html" target="_blank">오시는 길</a></li>
        <li><a href="javascript:void" @click="openTerm">이용약관</a></li>
        <li><a
          href="javascript:void(0)"
          class="personal_data"
          @click="openPolicy">개인정보처리방침</a></li>
      </ul>
      <div class="footer_company_info">
        <ul class="footer_address">
          <li class="branch_item">
            <strong class="branch_area">㈜멀티캠퍼스 본사</strong>
            <address class="branch_address">서울특별시 강남구 언주로 508 14층 (역삼동, 서울상록빌딩)</address>
          </li>
          <li class="branch_item">
            <strong class="branch_area">멀티캠퍼스 선릉</strong>
            <address class="branch_address">서울특별시 강남구 선릉로 428 (대치동 889-41)</address>
          </li>
          <li class="branch_item">
            <strong class="branch_area">멀티캠퍼스 세종대</strong>
            <address class="branch_address">서울특별시 광진구 능동로 195-16 6층 멀티캠퍼스 세종대(세종대학교 김원관 6층)</address>
          </li>
          <li class="branch_item">
            <strong class="branch_area">멀티캠퍼스 역삼</strong>
            <address class="branch_address">서울특별시 강남구 테헤란로 212 (역삼동 718-5번지)</address>
          </li>
        </ul>
        <div class="footer_business_info">
          <span>대표이사 : 정석목</span>
          <span>사업자등록번호 : 104-81-53114</span><br class="mo_only">
          <span>통신판매신고번호 : 제2016-서울강남-00151호</span><br class="mo_only">
          <span>개인정보관리 최고책임자 : 고민정 팀장</span>
        </div>
      </div>
      <span class="footer_copyright mo_only">COPYRIGHT BY MULTICAMPUS CO., LTD ALL RIGHTS RESERVED.</span>

      <div class="footer_customer_info">
        <div>
          <span>고객센터 <em>:</em> </span><strong>1544-9001</strong>
        </div>
        <div>
          <span>평일 <em>:</em> 08:00 ~ 20:00</span>
        </div>
        <div>
          <span>휴일 <em>:</em> 09:00 ~ 18:00 (점심시간 12:00 ~ 13:00 제외)</span>
        </div>
      </div>
      <span class="footer_copyright pc_only">COPYRIGHT BY MULTICAMPUS CO., LTD ALL RIGHTS RESERVED.</span>

      <ul class="footer_sns">
        <li><a target="_blank" href="https://m.post.naver.com/my.nhn?memberNo=44851817" class="naver">네이버</a></li>
        <li><a target="_blank" href="https://www.youtube.com/multicampus_official" class="youtube">유튜브</a></li>
        <li><a target="_blank" href="https://www.facebook.com/multicampus.official" class="facebook">페이스북</a></li>
      </ul>
    </div>
  </footer>
</template>

<!-- 공통 적용 스크립트 , 모든 페이지에 노출되도록 설치. 단 전환페이지 설정값보다 항상 하단에 위치해야함 -->
<script type="text/javascript" src="//wcs.naver.net/wcslog.js"> </script>
<script type="text/javascript">
if (!wcs_add) var wcs_add={};
wcs_add["wa"] = "s_4ab949ce6197";
if (!_nasa) var _nasa={};
if(window.wcs){
  wcs.inflow();
  wcs_do(_nasa);
}
</script>

<script>

import MmpFooterTerm from './MmpFooterTerm'
import MmpPrivacyPolicy from './MmpPrivacyPolicy'

export default {
  name: 'MmpFooter',
  computed: {
    hideFooter () {
      return this.$route.meta.hideFooter
    }
  },
  methods: {
    openTerm: async function () {
      await this.$popup.openModal(this.$el, MmpFooterTerm, {} )
    },
    openPolicy: async function () {
      await this.$popup.openModal(this.$el, MmpPrivacyPolicy, {} )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/layouts/MmpFooter.vue